import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.visible ? _c('my-modal', {
    attrs: {
      "data-sign": "maintenance_compliance_officer_add_edit_modal",
      "width": 600,
      "title": _vm.t('商品维护英国合规负责人')
    },
    on: {
      "cancel": _vm.handleClose,
      "ok": _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "maintenance_compliance_officer_add_edit_form",
      "model": _vm.formData,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801"),
      "label": _vm.t('商品编码'),
      "prop": "product_sku"
    }
  }, [_c('a-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.formData.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "product_sku", $$v);
      },
      expression: "formData.product_sku"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5408\u89C4\u8D1F\u8D23\u4EBA\u7F16\u7801"),
      "label": _vm.t('合规负责人编码'),
      "prop": "_compliance_officer_id"
    }
  }, [_c('my-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "option-filter-prop": "children",
      "data-permission": "product_compliance_officer_add_edit_batch_id_list",
      "id": "product_compliance_officer_add_edit_batch_id_list",
      "placeholder": _vm.t('请选择合规负责人')
    },
    model: {
      value: _vm.formData._compliance_officer_id,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "_compliance_officer_id", $$v);
      },
      expression: "formData._compliance_officer_id"
    }
  }, _vm._l(_vm.filterComplianceOfficerList, function (item) {
    return _c('a-select-option', {
      key: item.id,
      attrs: {
        "title": item.country_code + item.country_name + item.company
      }
    }, [_vm._v(" " + _vm._s(item.country_code) + "[" + _vm._s(item.country_name) + "] " + _vm._s(item.company) + " ")]);
  }), 1), _c('define-v-node', {
    attrs: {
      "vNode": _vm.getTipsHtml
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "maintenance_compliance_officer_add_edit_cancel",
      "data-permission": "maintenance_compliance_officer_add_edit_cancel",
      "id": "maintenance_compliance_officer_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-sign": "maintenance_compliance_officer_add_edit_submit",
      "data-permission": "maintenance_compliance_officer_add_edit_submit",
      "id": "maintenance_compliance_officer_add_edit_submit",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)], 1) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };